import http from "../http";

const apiUrl = `${process.env.REACT_APP_API_URL}`;

export function getAgentList(params) {
  return http.get(`${apiUrl}users/all-agent`, { params });
}

export function getAgentMinimalList(params) {
  return http.get(`${apiUrl}users/all-agent-minimal-data`, { params });
}

export function getAgentListReport(params) {
  return http.get(`${apiUrl}users/all-agent-report`, { params });
}

export function getAgentReport(id, params) {
  return http.get(`${apiUrl}users/agent-report/${id}`, { params });
}

export function getCountAgentStatus() {
  return http.get(`${apiUrl}users/agent-status-count`);
}

export function getSingleAgent(id) {
  return http.get(`${apiUrl}users/find-agent/${id}`);
}

export function handleAgentStatus(data) {
  return http.patch(`${apiUrl}users/update-agent/${data.id}`, {
    isActive: data?.isActive,
  });
}

export function approveAgent(id, data) {
  return http.put(`${apiUrl}users/approve-agent/${id}`, data);
}

export function generateB2bToken(data) {
  return http.post(`${apiUrl}agents/generate-b2b-login-token`, data);
}

export function handleAgentDelete(id) {
  return http.delete(`${apiUrl}users/remove-agent/${id}`);
}

export function updateAgent(id, data) {
  return http.patch(`${apiUrl}users/update-agent/${id}`, data);
}

export function getAgentLedgerData(id, limit, pageNumber, searchString) {
  let queryParams = `b2bUserId=${id}&limit=${limit}&page=${pageNumber}`;

  if (searchString) {
    queryParams += `&searchString=${encodeURIComponent(searchString)}`;
  }

  return http.get(
    `${apiUrl}user-account-ledger/findByB2bUserId?${queryParams}`
  );
}

export function getAllUserAccountLedger(limit, pageNumber, searchString) {
  let queryParams = `limit=${limit}&page=${pageNumber}`;

  if (searchString) {
    queryParams += `&searchString=${encodeURIComponent(searchString)}`;
  }

  return http.get(`${apiUrl}user-account-ledger?${queryParams}`);
}



export function getAgentBookingQue(id, limit, pageNumber, status) {
  return http.get(
    `${apiUrl}air-bookings/findByB2bUserId?page=${pageNumber}&limit=${limit}&b2bUserId=${id}&bookingStatus=${status}`
  );
}

export function getAgentBookData(id, limit, pageNumber, status, bookingStatus) {
  return http.get(
    `${apiUrl}air-refund-request/findByB2bUserId?page=${pageNumber}&limit=${limit}&type=${bookingStatus}&b2bUserId=${id}&status=${status}`
  );
}

export function getAgentReissueData(id, limit, pageNumber, status) {
  return http.get(
    `${apiUrl}air-reissue-request/findByB2bUserId?page=${pageNumber}&limit=${limit}&b2bUserId=${id}&status=${status}`
  );
}

export function getAgentSsrData(id, limit, pageNumber, status) {
  return http.get(
    `${apiUrl}air-ssr-request/findByB2bUserId?page=${pageNumber}&limit=${limit}&b2bUserId=${id}&status=${status}`
  );
}

export function updateAgentLedgerBalance(id, data) {
  return http.patch(
    `${apiUrl}user-balance/agent/update-ledger-balance/${id}`,
    data
  );
}

export function getUserAccountLedger(id) {
  return http.get(`${apiUrl}user-account-ledger/${id}`);
}

export function updateUserBalanceReconciliation(agentId, data) {
  return http.patch(
    `${apiUrl}user-balance/agent/reconciliation/${agentId}`,
    data
  );
}

export function updateUserAccountLedger(id, data) {
  return http.patch(`${apiUrl}user-account-ledger/${id}`, data);
}


export function deleteUserAccountLedger(id) {
  return http.delete(`${apiUrl}user-account-ledger/${id}`);
}
